export class SessionData {
    username?: string;
    channel?: string;           // NBP ou NBE
    selectedLanguage?: string;
    agreementType?: string;     // AISP; PISP
    agreementId?: string;       // id do consentimento
    entityName?: string;        // Nome do TPP
    sessionToken?: string;      // token de autenticação para sessão open banking
    securityToken?: string;     // token de autenticação para invocação de trxs
    isLoginOk?: boolean;
    isOtpOk?: boolean;
    isConfirmed?: boolean;
    isOnConfirmPage: boolean;
    paymentType?: string;
    paymentAmount?: string;
    paymentCurrency?: string;
    providerLink?: string;
    paymentBenef?: string;
    safActivated?: string;
    givenAccount: boolean;
    isToSelectAccount?: boolean;
    isToSelectPaymentAccount?: string;
    selectedPaymentAccount: any;
    selectedConsentAccounts?: any[];
    agreementMap: string;
    entryParam: string;
    hasSentSms: boolean;
    isClickCall: boolean;
    confirmedClickCall: boolean;
    isScheduleOperation: boolean;
    isPeriodicOperation: boolean;
    isBSTP: boolean;
    isBSTE: boolean;
    need2FA: boolean;
    isTimeout: boolean;
    P2hoCyPjpg: string;
    fToken: string;
    strongAuthSms: boolean;
    messageDescription: string;
    isPendingConfirm: boolean;
    isLocked: boolean;
    cannotSignOperation: boolean;
    deviceId: string;

    // Lotes
    errorLotes: string;
    listErrors: any [];
    numberDetails: string;
    hasImpeditiveErrors: boolean;


    // APP ou WEB
    isApp: boolean;
    requestExpired: boolean;

    // OTP LIST
    safActive: boolean;
}
